/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useTag } from '@api/hooks';
import { InfoItem } from '@molecules';
import { pluralize } from '@utils';

const Item = ({ className, module, previewImg, errors }) => {
  const { tag, error } = useTag(module.content.tagId);
  const articles = module.content.slides;

  let description = pluralize(articles?.length, 'article');

  if (module.content.tagId) {
    description = error ? 'Error loading tag' : tag?.tag || 'loading tag...';
  }

  return (
    <InfoItem.WithError error={errors} size="large" image={previewImg} description={description}>
      News Carousel
    </InfoItem.WithError>
  );
};

export default Item;
